<template>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    aria-hidden="true"
  >
    <path d="m12.81 17.58 4.92-2.33a.2.2 0 0 0 .09-.27.2.2 0 0 0-.08-.08l-4.92-2.47a.2.2 0 0 0-.3.18v4.79a.2.2 0 0 0 .2.2.2.2 0 0 0 .1-.02Z" />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 0a2 2 0 0 0-2 2v26c0 1.1.9 2 2 2h26a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Zm7.74 8.7h10.52A3.74 3.74 0 0 1 24 12.4v5.2a3.7 3.7 0 0 1-3.74 3.7H9.74A3.74 3.74 0 0 1 6 17.6v-5.2a3.7 3.7 0 0 1 3.74-3.7Z" />
  </svg>
</template>
